import Mail from '@/components/icons/mail';
import React from 'react';
import { inter } from '@/styles/fonts';
import { Button } from '@/components/ui/button';

interface ThankyouMessageProps {
  setIsFormSubmitted: React.Dispatch<React.SetStateAction<boolean>>;
}

const ThankyouMessage = ({ setIsFormSubmitted }: ThankyouMessageProps) => {
  const handleClick = () => {
    setIsFormSubmitted(false);
  };

  return (
    <div
      className={`${inter.className} flex flex-col items-center gap-y-6 text-center text-white lg:px-10 lg:py-10`}
    >
      <Mail className="h-8 w-8" />
      <h2 className="items-stretch text-2xl font-semibold">
        Thank you for requesting a quote!
      </h2>
      <p className="mx-auto max-w-[600px]">
        We have received your quote request, and one of our account
        representatives will get back to you within 24 hours.
      </p>
      <Button
        onClick={handleClick}
        variant={'ghost'}
        className="w-full max-w-[295px] rounded-full border border-white text-white"
      >
        Request New Quote
      </Button>
    </div>
  );
};

export default ThankyouMessage;
